export const translate = (tableName: string, keyToTranslate: string, translations: any) => {
  
  return keyToTranslate
    .split('.')
    .map((key) => translations?.[tableName]?.[key] ? translations[tableName][key] : key)
    .join('/');
}

export const translateByField = (
  keyToTranslate: string,
  translationsFields: any,
): string => {
  if(!translationsFields) {
    return keyToTranslate
  }
  for (const group of Object.values(translationsFields)) {
    for (const [key, value] of Object.entries(group)) {
      if (key === keyToTranslate) {
        return value;
      }
    }
  }
  return keyToTranslate;
};

export const translateByFieldLast = (keyToTranslate: string, translationsFields: any) => {
  const keyToTranslateArray = keyToTranslate
    .split('.')
    .map((key) => translationsFields?.[key] ? translationsFields[key] : key);
    
  return keyToTranslateArray[keyToTranslateArray.length - 1];
}

export const translateRelation = (key: string, translations) => {
  if(key === 'GTS_INVOICE') {
    return '';
  }
  return (translations['RELATION'][key]) ? translations['RELATION'][key] : '';
}

export const getTableName = (key: string, relations: Array<any>, ID_RELATORIO: number, fieldRelations?: Array<any>) => {
  const keyArray = key.split('.');
  const keyToTranslate = keyArray[keyArray.length - 1];

  if (keyArray.length === 1) {
    // Verifica se há uma relação de campo para este atributo
    // Isso é necessário para campos como ID_PAIS_ORIGEM que devem usar a relação paisOrigem.SIGLA_PAIS
    if (fieldRelations && fieldRelations.length > 0) {
      const defaultTableName = ID_RELATORIO === 7 ? 'GTS_PROCESSO_EMBARQUE' : 
                              (ID_RELATORIO === 10 || ID_RELATORIO === 9) ? 'GTS_TRIAGEM' : 
                              'GTS_INVOICE';
      
      const fieldRelation = fieldRelations.find((fr: any) => 
        fr.NOME_ATRIBUTO === keyToTranslate && 
        fr.NOME_TABELA_ORIGEM === defaultTableName
      );
      
      if (fieldRelation) {
        // Se encontrou uma relação, usa a tabela e atributo da relação
        return {
          tableName: fieldRelation.NOME_TABELA,
          keyToTranslate: fieldRelation.NOME_ATRIBUTO_REL,
        };
      }
    }
    
    if(ID_RELATORIO === 7) {
      return {
        tableName: 'GTS_PROCESSO_EMBARQUE',
        keyToTranslate,
      };
    }
    if(ID_RELATORIO === 10 || ID_RELATORIO === 9) {
      return {
        tableName: 'GTS_TRIAGEM',
        keyToTranslate,
      };
    }
    return {
      tableName: 'GTS_INVOICE',
      keyToTranslate,
    };
  }

  let tableName = keyArray[keyArray.length - 2];

  const relation = relations.find((relation) => tableName === relation.columnName);

  return {
    tableName: relation?.tableName || 'DefaultTableName',
    keyToTranslate: keyToTranslate || key,
  };
}
